module.exports = __webpack_public_path__ + "static/media/opakowania_01_A.e51eb4a1.png";